import React, { FC } from "react";
import classNames from "classnames";

import { RegularText } from "components/RegularText/RegularText";

interface TextPointerProps {
  text: string;
  pointer: string;
  firstTextClassName?: string;
  secondTextClassName?: string;
}

export const TextPointer: FC<TextPointerProps> = (props): JSX.Element => {
  const { text, pointer, firstTextClassName, secondTextClassName } = props;
  return (
    <div className="flex items-center">
      <RegularText className={classNames("mr-2", firstTextClassName || "")}>
        {text}
      </RegularText>
      <RegularText className={secondTextClassName || ""}>{pointer}</RegularText>
    </div>
  );
};
